module.exports = __webpack_public_path__ + "img/cloud-upload.c3f5c2ef.png";